<script setup lang="ts">
import type { KirbyBlock } from "#nuxt-kirby";

const props = defineProps<{
  block?: KirbyBlock<"bestHikesTable">;
}>();

const defaultHikes = [
  {
    name: "Walker's Haute Route",
    region: "Valais",
    type: "Multi-day Trek",
    difficulty: "Challenging",
    duration: "12-14 Days",
    bestFor: "Fit Trekkers",
    url: "/walkers-haute-route",
  },
  {
    name: "Tour of the Jungfrau",
    region: "Bernese Oberland",
    type: "Multi-day Trek",
    difficulty: "Challenging",
    duration: "9 Days",
    bestFor: "Classic Alpine views",
    url: "/tour-of-the-jungfrau",
  },
  {
    name: "Oeschinensee Panorama Trail",
    region: "Bernese Oberland",
    type: "Day Hike",
    difficulty: "Moderate",
    duration: "3-4 Hours",
    bestFor: "Photographers",
  },
  {
    name: "Zermatt's 5 Lakes Walk",
    region: "Valais",
    type: "Day Hike",
    difficulty: "Easy",
    duration: "2.5-3 Hours",
    bestFor: "Families & Novices",
  },
  {
    name: "Schäfler Ridge",
    region: "Eastern Switzerland",
    type: "Day Hike",
    difficulty: "Moderate - Hard",
    duration: "4-5 Hours",
    bestFor: "Thrill Seekers",
  },
  {
    name: "Stoos Ridge Trail",
    region: "Central Switzerland",
    type: "Day Hike",
    difficulty: "Moderate",
    duration: "2-3 Hours",
    bestFor: "Panoramic Views",
  },
  {
    name: "Via Engiadina Segment",
    region: "Graubünden",
    type: "Day Hike",
    difficulty: "Moderate",
    duration: "4-6 Hours",
    bestFor: "Quiet Nature",
  },
  {
    name: "Sentiero Verzasca",
    region: "Ticino",
    type: "Day Hike",
    difficulty: "Easy - Moderate",
    duration: "3.5-4 Hours",
    bestFor: "Riverside Beauty",
  },
  {
    name: "Jura Crest Trail Segment",
    region: "Jura",
    type: "Day Hike",
    difficulty: "Easy",
    duration: "3-4 Hours",
    bestFor: "Gentle Hiking",
  },
  {
    name: "Rochers de Naye",
    region: "Lake Geneva",
    type: "Day Hike",
    difficulty: "Moderate",
    duration: "3-4 Hours (descent)",
    bestFor: "Lake Views",
  },
];

const hikes = computed(() => {
  const content = props.block?.content as
    | {
        hikes?: Array<{
          name?: string;
          region?: string;
          type?: string;
          difficulty?: string;
          duration?: string;
          bestFor?: string;
          url?: string;
        }>;
      }
    | undefined;
  const fromCms = content?.hikes?.length ? content.hikes : null;
  return fromCms ?? defaultHikes;
});
</script>

<template>
  <div class="best-hikes-table-container">
    <table class="best-hikes-table">
      <thead>
        <tr>
          <th>Hike name</th>
          <th>Region</th>
          <th>Type</th>
          <th>Difficulty</th>
          <th>Duration</th>
          <th>Best for</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(hike, index) in hikes"
          :key="index"
          :class="{ 'row-even': index % 2 === 1 }"
        >
          <td>
            <NuxtLink v-if="hike.url" :to="hike.url">{{ hike.name }}</NuxtLink>
            <span v-else>{{ hike.name }}</span>
          </td>
          <td>{{ hike.region }}</td>
          <td>{{ hike.type }}</td>
          <td>{{ hike.difficulty }}</td>
          <td>{{ hike.duration }}</td>
          <td>{{ hike.bestfor }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
